import { useSyncExternalStore } from 'react';

/** Values only the browser knows. Pages are rendered on the server first, and
 *  the browser's first render has to match that markup, so these answer the
 *  server's value during hydration and the real one straight after. */

const never = () => () => {};

/** False on the server and during hydration, true from then on. */
export function useHydrated(): boolean {
  return useSyncExternalStore(never, () => true, () => false);
}

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

function subscribeMotion(onChange: () => void): () => void {
  if (!window.matchMedia) return () => {};
  const mql = window.matchMedia(REDUCED_MOTION);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

/** Honours `prefers-reduced-motion: reduce`. True on the server, so the first
 *  response carries a still and no film starts before the browser has checked;
 *  a page reached by a link inside the shop reads the real setting at once. */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribeMotion,
    () => !!window.matchMedia?.(REDUCED_MOTION).matches,
    () => true,
  );
}
